var React = require('react');

function NextArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.29297 0.293C0.105499 0.480528 0.000183105 0.734836 0.000183105 1C0.000183105 1.26516 0.105499 1.51947 0.29297 1.707L6.58597 8L0.29297 14.293C0.110812 14.4816 0.0100173 14.7342 0.0122957 14.9964C0.0145741 15.2586 0.119743 15.5094 0.305151 15.6948C0.490559 15.8802 0.741372 15.9854 1.00357 15.9877C1.26577 15.99 1.51837 15.8892 1.70697 15.707L8.70697 8.707C8.89444 8.51947 8.99976 8.26516 8.99976 8C8.99976 7.73484 8.89444 7.48053 8.70697 7.293L1.70697 0.293C1.51944 0.105529 1.26513 0.000213623 0.999969 0.000213623C0.734805 0.000213623 0.480497 0.105529 0.29297 0.293V0.293Z","fill":"#3D2B30"}));
}

NextArrow.defaultProps = {"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none"};

module.exports = NextArrow;

NextArrow.default = NextArrow;
